import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const api = useApi();
  const [state, setState] = useState({ loading: true, me: null, error: null });
  const load = useCallback(async () => {
    try {
      const me = await api("get", "/me");
      setState({ loading: false, me, error: null });
    } catch (e) {
      setState({ loading: false, me: null, error: e?.response?.status === 403 ? "not_enrolled" : "error" });
    }
  }, [api]);
  useEffect(() => { load(); }, [load]);
  const value = { ...state, reload: load, isAdmin: state.me?.role === "admin" };
  return <MeCtx.Provider value={value}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
